import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const headers = new HttpHeaders({
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin':'*',
});

@Injectable({
  providedIn: 'root'
})
export class QuotationsService {
  apiurl: string = '';

  // (local dev)
  //apiurl = 'https://localhost:44397/api';

  //(remote dev)
  //apiurl = 'http://apps-web1-dev:8088/api';

  //(remote stg)
  //apiurl = 'http://apps-web1-stg:92/api';

  //(production 1)
  //apiurl = 'http://quotations-prd.ad.uwc.ac.za:81/api';

  //(production 2)
  //apiurl = 'https://quote-api.uwc.ac.za/api';

  constructor(private http: HttpClient) { }

  generateReport(reportData, modules, totals, proformaDetail) {
    return this.http.post(this.apiurl + '/reports/generatereport', { reportData, modules, totals, proformaDetail }, {responseType:'text', headers: headers});
  }

  getAcademicYears() {
    return this.http.get(this.apiurl + '/listitem/getacademicyears', { headers: headers });
  }

  getCurrentDateFull(){
    return this.http.get(this.apiurl + '/listitem/getCurrentDateFull', {responseType:'text', headers: headers });
  }

  getDegreeTypes() {
    return this.http.get(this.apiurl + '/listitem/getdegreetypes', { headers: headers });
  }

  getGraduationTypes() {
    return this.http.get(this.apiurl + '/listitem/getgraduationtypes', { headers: headers });
  }

  getStudyTypes() {
    return this.http.get(this.apiurl + '/listitem/getstudytypes', { headers: headers });
  }

  getFaculties() {
    return this.http.get(this.apiurl + '/listitem/getfaculties', { headers: headers });
  }

  getProgrammes(year: number, degreeTypeId: string, gradTypeId: string, studyTypeId: string, facultyId: string) {
    return this.http.post(this.apiurl + '/listitem/getprogrammes', { year, degreeTypeId, gradTypeId, studyTypeId, facultyId }, { headers: headers });
  }

  getPersonTitles() {
    return this.http.get(this.apiurl + '/listitem/getpersontitles', { headers: headers });
  }

  async getGenders() {
    return await this.http.get(this.apiurl + '/listitem/getgenders', { headers: headers }).toPromise();
  }

  getResidences(year: number, faculty: string, gradType: string, programmeDuration: number, yearLevel: number) {
    return this.http.post(this.apiurl + '/residence/getresidences', { year, faculty, gradType, programmeDuration, yearLevel }, { headers: headers });
  }

  getRegistrationFee() {
    return this.http.get(this.apiurl + '/programme/getregistrationfee', {headers: headers});
  }

  getDownPayments() {
    return this.http.get(this.apiurl + '/programme/getdownpayments', {headers: headers});
  }

  hasAcademicRules(year: number, programme: number, stream: string, yearLevel: number) {
    return this.http.post(this.apiurl + '/programme/hasacademicrules', {year, programme, stream, yearLevel}, { headers: headers });
  }

  getModuleProgramme(year: number, programme: number, stream: string, studyType: string, yearLevel: number) {
    return this.http.post(this.apiurl + '/programme/getmoduleprogramme', {year, programme, stream, studyType, yearLevel}, { headers: headers });
  }
}
